
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"81","height":"81","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"80","height":"80","rx":"40","fill":"#00A351"}}),_c('path',{attrs:{"d":"M58.834 28.984l-2.65-2.65a3.34 3.34 0 00-4.717 0l-14.8 14.8c-.65.65-1.7.65-2.35 0l-4.8-4.8a3.34 3.34 0 00-4.716 0l-2.65 2.65a3.34 3.34 0 000 4.717l10.966 10.983a3.305 3.305 0 002.35.984c.884 0 1.734-.35 2.35-.984l20.984-20.966a3.34 3.34 0 000-4.717l.033-.017z","fill":"#fff"}})])
          )
        }
      }
    